/* Pestañas de información de la ficha de producto.
   Accesible: roles tab/tabpanel, flechas izquierda/derecha e Inicio/Fin.

   OJO con el momento de inicialización: si el <script> se carga sin defer, el
   componente se define mientras el navegador aún está parseando la etiqueta
   <offers-tabs> y connectedCallback se dispara ANTES de que existan los botones.
   Por eso el script va con defer y, además, aquí se reintenta si al conectar
   todavía no hay hijos. */
(function () {
  if (customElements.get('offers-tabs')) return;

  class OffersTabs extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[role="tab"]')) {
        this.init();
      } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.init.bind(this), { once: true });
      } else {
        requestAnimationFrame(this.init.bind(this));
      }
    }

    init() {
      if (this.ready) return;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;
      this.ready = true;

      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          this.select(i);
        }.bind(this));

        tab.addEventListener('keydown', function (e) {
          var last = this.tabs.length - 1;
          var next = null;
          if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
          else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = last;
          if (next !== null) { e.preventDefault(); this.select(next); this.tabs[next].focus(); }
        }.bind(this));
      }.bind(this));

      this.select(0);
    }

    select(index) {
      this.tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (this.panels[i]) this.panels[i].hidden = !on;
      }.bind(this));
    }
  }

  customElements.define('offers-tabs', OffersTabs);
})();
